export default [
  {
    path: "/scanCodeAdd",  //扫码创建
    name: 'scanCodeAdd',
    meta: {
      keepAlive: true // 需要缓存
    },
    component: () => import("@/views/scan/scanCodeAdd.vue")
  },
  {
    path: "/scanDetail",    //扫码确认详情
    name: 'scanDetail',
    component: () => import("@/views/scan/scanDetail.vue")
  },
  {
    path: "/scanConfirm",    //扫码创建
    name: 'scanConfirm',
    component: () => import("@/views/scan/scanConfirm.vue")
  }
]
